<template>
  <div class="duty-edit">
    <el-dialog title="编排详情" :visible="dutyArrangeDetailShow" @open="dialogOpen" @close="dialogClose"
      :close-on-click-modal="false" width="600px" center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="编排名称:" prop="dutyName">
          <el-input v-model="ruleForm.dutyName" placeholder="请输入编排名称" disabled></el-input>
        </el-form-item>
        <el-form-item label="学年:" prop="schoolYearVal" required label-width="100px">
          <!-- <el-date-picker v-model="ruleForm.schoolYearVal" type="year" placeholder="学年" disabled>
          </el-date-picker> -->
          <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYearVal" disabled />
        </el-form-item>
        <el-form-item label="学期:" prop="semesterVal" required label-width="100px">
          <el-select v-model="ruleForm.semesterVal" disabled placeholder="学期">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="时间范围:" prop="date" required>
          <el-date-picker
            v-model="ruleForm.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            disabled
          >
          </el-date-picker
        ></el-form-item> -->
        <el-form-item label="编排说明:" prop="notice" label-width="100px">
          <el-input type="textarea" v-model="ruleForm.notice" :rows="10" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["dutyArrangeDetailShow", "dutyInfo", "semesterOptions"],
  data() {
    return {
      ruleForm: {
        dutyName: "", // 名称
        date: "", // 时间
        notice: "", // 说明
        schoolYearVal: "",
        semesterVal: "",
      },
      rules: {
        dutyName: [
          { required: true, message: "请输入编排名称", trigger: "blur" },
        ],
        notice: [
          { required: true, message: "请输入编排说明", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    dialogOpen() {
      this.ruleForm.dutyName = this.dutyInfo.dutyName;
      this.ruleForm.schoolYearVal = this.dutyInfo.schoolYear;
      this.ruleForm.semesterVal = this.dutyInfo.semester;
      this.ruleForm.notice = this.dutyInfo.notice.replace(/<br\/>/g, "\n");
      this.ruleForm.date = [this.dutyInfo.startDate, this.dutyInfo.endDate];
    },
    dialogClose() {
      this.$emit("update:dutyArrangeDetailShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./duty-arrange-detail.scss";
</style>